import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'
import {
  useInitRemoteConfig,
  RemoteConfigProvider as RemoteConfProvider,
} from 'reactfire'

import { Loading } from 'components/Loading/Loading'

import { defaultConfig } from 'constants/defaultConfig'
import { isProd } from 'utils/isProd'

export function RemoteConfigProvider({ children }) {
  const { status, data: remoteConfigInstance } = useInitRemoteConfig(
    async (firebaseApp) => {
      const remoteConfig = getRemoteConfig(firebaseApp)
      remoteConfig.defaultConfig = defaultConfig

      if (!isProd()) {
        remoteConfig.settings = {
          minimumFetchIntervalMillis: 300000,
          fetchTimeoutMillis: 60000,
        }
      }

      await fetchAndActivate(remoteConfig)
      return remoteConfig
    },
  )

  if (status === 'loading') {
    return <Loading />
  }

  return (
    <RemoteConfProvider sdk={remoteConfigInstance}>
      {children}
    </RemoteConfProvider>
  )
}
